import { Component } from "react";
import { AlertTriangle } from "lucide-react";
import { BackButton } from "./BackButton";

// React only supports error boundaries as class components — there is no
// hooks equivalent (no useErrorBoundary). This catches render/lifecycle
// errors thrown by whatever page it wraps so one broken screen shows a
// recoverable message instead of taking the whole app down to a blank tab.
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Uncaught render error:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="w-full h-full flex-1 flex flex-col items-center justify-center gap-6 px-4 text-center">
          <AlertTriangle size={40} className="text-rose-500" />
          <div className="space-y-2">
            <h1 className="text-xl sm:text-2xl font-black italic uppercase tracking-tighter text-white">
              Something Broke
            </h1>
            <p className="text-xs font-mono text-zinc-500 max-w-sm">
              This screen hit an unexpected error. Your progress on other pages is unaffected.
            </p>
          </div>
          <div className="flex items-center gap-6">
            <button
              onClick={() => this.setState({ error: null })}
              className="text-xs font-mono font-bold uppercase tracking-widest text-indigo-400 hover:text-indigo-300 transition-colors"
            >
              Try Again
            </button>
            <BackButton onClick={() => { this.setState({ error: null }); window.location.href = "/"; }} />
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
